import SkeletonComponent from "../SkeletonComponent/SkeletonComponent";
import styled from "styled-components";
import LinkButton from "../LinkButton/LinkButton";
import { useTranslation } from "react-i18next";

export type LoadMoreProps = {
  numberToLoad: number;
  isLoading: boolean;
  loadMore: () => void;
  styles: { OverallGeneralTextColour: string };
};

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const LoadMore: React.FC<LoadMoreProps> = ({
  numberToLoad,
  isLoading,
  loadMore,
  styles,
}) => {
  const { t } = useTranslation();
  const getBody = () => {
    if (isLoading) {
      return (
        <SkeletonContainer>
          <SkeletonComponent shape={"rounded"} width={220} height={18} />
          <SkeletonComponent width={184} height={18} shape="rounded" />
        </SkeletonContainer>
      );
    }
    const getButtonText = (numberToLoad: number) => {
      if (numberToLoad === 1) {
        return t("LoadOneMoreLocation");
      }
      return t("LoadXMoreLocation", { number: numberToLoad });
    };

    return (
      <LinkButton
        onClick={loadMore}
        textColour={styles.OverallGeneralTextColour}
      >
        {getButtonText(numberToLoad)}
      </LinkButton>
    );
  };
  return getBody();
};

export default LoadMore;
